<div *ngIf="cart$ | async" class="order-action-inner">
  <div class="row order-ship-holder">
    <div class="col-md-6 pl-0">
      <div>
        <label
          class="order-heading order-shipping-label"
          [ngClass]="quoteCartType ? 'disabled' : ''"
          >{{ "savedCart.orderShipped" | cxTranslate }}</label
        >
      </div>
      <div class="vs-radio-button">
        <input
          id="complete-ship-radio"
          type="radio"
          value="complete"
          name="ship-type-radio-group"
          [checked]="!cart.partialShipping"
          (change)="changeShippingType($event)"
          [ngClass]="
            quoteCartType || !checkCompleteValidation() ? 'disabled' : ''
          "
        />
        <label
          for="complete-ship-radio"
          class="complete-label"
          [ngClass]="
            quoteCartType || !checkCompleteValidation() ? 'disabled' : ''
          "
        >
        {{ "savedCart.complete" | cxTranslate }}
        </label>
        <input
          id="partial-ship-radio"
          type="radio"
          value="partial"
          name="ship-type-radio-group"
          [checked]="cart.partialShipping"
          (change)="changeShippingType($event)"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        />
        <label
          for="partial-ship-radio"
          class="partial-label"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        >
        {{ "savedCart.partial" | cxTranslate }}
        </label>
      </div>
    </div>

    <div
      class="col-md-6"
      *ngIf="cart.consolidatedDay && cart.consolidatedDay != ''"
    >
      <div>
        <label
          class="order-heading order-shipping-label"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        >
          <span>{{ "savedCart.wantConsolidatedShipment" | cxTranslate }}</span>
          <i
            class="material-icons ml-1"
            matTooltipClass="vs-tooltip"
            matTooltip='{{ "savedCart.shipmentTooltipTxt" | cxTranslate }}'
            >info</i
          >
        </label>
      </div>
      <div class="vs-radio-button">
        <input
          id="cons-shipment-true-radio"
          type="radio"
          value="true"
          name="cons-ship-radio-group"
          [checked]="cart.isConsolidatedShipment"
          (change)="changeConsShipment($event)"
          #consShipTrue
          [ngClass]="quoteCartType ? 'disabled' : ''"
        />
        <label
          for="cons-shipment-true-radio"
          class="complete-label"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        >
        {{ "savedCart.yesLabel" | cxTranslate }}
        </label>
        <input
          id="cons-shipment-false-radio"
          type="radio"
          value="false"
          name="cons-ship-radio-group"
          [checked]="!cart.isConsolidatedShipment"
          (change)="changeConsShipment($event)"
          #consShipFalse
          [ngClass]="quoteCartType ? 'disabled' : ''"
        />
        <label
          for="cons-shipment-false-radio"
          class="partial-label"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        >
        {{ "savedCart.noLabel" | cxTranslate }}
        </label>
      </div>
    </div>
  </div>
  <div class="row commission-section" *ngIf="commissionEligibleDisplay">
    <div class="col-md-6 pl-0" [ngClass]="quoteCartType ? 'disabled' : ''">
      <!-- <div class="vs-commission-box">
        <input
          type="checkbox"
          id="commission"
          name="vs-commission"
          [(ngModel)]="commissionModel"
          [disabled]='commissionModel'
          (change)="updateSalesOrderCommmission($event)"
        />
        <label for="commission" class="commission-txt" [ngClass]="commissionModel ? 'disabled' : ''"
          >Order is commission eligible
         </label
        > <i
            class="material-icons"
            matTooltipClass="vs-tooltip"
            matTooltip="is This Order is commision eligible"
            >info</i
          >
      </div> -->
      <div>
        <label
          class="order-heading order-shipping-label"
          [ngClass]="quoteCartType ? 'disabled' : ''"
          >{{ "savedCart.orderEligible" | cxTranslate }}
          <i
            class="material-icons ml-1"
            matTooltipClass="vs-tooltip"
            matTooltip='{{ "savedCart.orderTooltipTxt" | cxTranslate }}'
            >info</i
          ></label
        >
      </div>
      <div class="vs-radio-button">
        <input
          id="commission-radio-yes"
          type="radio"
          [value]="true"
          name="commission-type-radio-group"
          [checked]="commissionModel == true ? true : false"
          [(ngModel)]="commissionModel"
          (change)="updateSalesOrderCommmission($event)"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        />
        <label
          for="commission-radio-yes"
          class="complete-label ml-3"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        >
        {{ "savedCart.yesLabel" | cxTranslate }}
        </label>
        <input
          id="commission-radio-no"
          type="radio"
          [value]="false"
          name="commission-type-radio-group"
          [(ngModel)]="commissionModel"
          [checked]="commissionModel == false ? true : false"
          (change)="updateSalesOrderCommmission($event)"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        />
        <label
          for="commission-radio-no"
          class="partial-label"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        >
        {{ "savedCart.noLabel" | cxTranslate }}
        </label>
      </div>
    </div>
    <div
      class="col-md-6 sold-to-dropdown"
      *ngIf="commissionModel && soldToAddress$ | async as soldToAddresses"
    >
      <label
        class="order-heading float-left"
        [ngClass]="quoteCartType ? 'disabled' : ''"
        >{{ "savedCart.soldtoAddress" | cxTranslate }}
      </label>

      <ng-select
        [clearable]="false"
        [searchable]="true"
        [(ngModel)]="soldToAddress"
        placeholder="Select"
        class="sold-to-container"
        (change)="setSoldToAddress($event)"
        [class.error]="proceedClicked && soldToAddress == null"
        [ngClass]="
          proceedClicked && soldToAddress == null ? 'border-danger' : ''
        "
      >
        <ng-option
          *ngFor="let address of soldToAddresses?.b2bUnits"
          [value]="address"
        >
          {{ address?.name }}
        </ng-option>
      </ng-select>
      <label class="error" *ngIf="proceedClicked && soldToAddress == null"
        >{{ "savedCart.pleaseSelectSoldToAddres" | cxTranslate }}</label
      >
    </div>
  </div>
  <div class="row order-date-holder">
    <div class="vs-text-field col-md-6 pl-0">
      <label class="order-heading" [ngClass]="quoteCartType ? 'disabled' : ''">
        <span>{{ "savedCart.promisedShipDate" | cxTranslate }}</span>
        <i
          class="material-icons ml-1"
          matTooltipClass="vs-tooltip"
          matTooltip='{{ "savedCart.useTooltipTxt" | cxTranslate }}'
          >info</i
        >
      </label>
      <div class="apply-all-holder">
        <vs-date-picker
          class="apply-all-date"
          (selectedDate)="onDateChange($event)"
          [min]="minDate"
          [defaultDate]="defaultHeaderDate"
          [showError]="consShipDateApplyError"
          [filterWeekend]="filterWeekend"
          [activateSelectedDay]="cart?.isConsolidatedShipment"
          [selectedDay]="selectedDay"
          #applyAllDatePicker
          [ngClass]="quoteCartType ? 'disabled' : ''"
        >
        </vs-date-picker>
        <button
          class="vs-tertiary-btn apply-btn-button"
          (click)="applyReqShipDate()"
          [disabled]="quoteCartType"
          [ngClass]="quoteCartType ? 'disabled' : ''"
        >
          <span *ngIf="!showShipDateLoader">{{ "savedCart.applyToAll" | cxTranslate }}</span>
          <div
            *ngIf="showShipDateLoader"
            class="apply-ship-date-spinner cx-spinner"
          >
            <cx-spinner></cx-spinner>
          </div>
        </button>
        <label class="error cons-ship-error" *ngIf="consShipDateApplyError"
          >{{ "savedCart.selectShipDate" | cxTranslate }}
          </label
        >
      </div>
    </div>
    <div
      class="col-md-6 order-type-dropdown"
      *ngIf="orderTypes$ | async as orderType"
    >
      <label
        class="order-heading float-left"
        [ngClass]="quoteCartType ? 'disabled' : ''"
        >{{ "savedCart.orderType" | cxTranslate }}
      </label>

      <ng-select
        [clearable]="false"
        [searchable]="false"
        [(ngModel)]="orderTypeValue"
        (change)="sendOrderType($event)"
        [ngClass]="quoteCartType ? 'disabled' : ''"
      >
        <ng-option
          *ngFor="let type of orderType?.orderType"
          [value]="type?.code"
          ng-selected="(cart.cartOrderType?.code == type?.code || type?.code == orderTypeEnum.RESALE) ? true: false"
        >
          {{ type?.name }}
        </ng-option>
      </ng-select>
    </div>
  </div>
</div>
